import { render, staticRenderFns } from "./ManipulableImage.vue?vue&type=template&id=4b0c9f1a&scoped=true&"
import script from "./ManipulableImage.vue?vue&type=script&lang=ts&"
export * from "./ManipulableImage.vue?vue&type=script&lang=ts&"
import style0 from "./ManipulableImage.vue?vue&type=style&index=0&id=4b0c9f1a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c9f1a",
  null
  
)

export default component.exports